import { AUTH_API_GW_URL, ROUTES_NAMES } from '@/constants';
import { User } from '@/model/user';
import store from '@/store';
import Auth, { CognitoUser } from '@aws-amplify/auth';
import { CognitoUserSession } from 'amazon-cognito-identity-js';
import axios from 'axios';
import { redirectToCallbackURL } from './cognitoService';
import router from '@/router';

const API = axios.create({
  baseURL: AUTH_API_GW_URL
});

export const federatedRegistration = async (user: User, username: string): Promise<void> => {
  // eslint-disable-next-line no-useless-catch
  try {
    await API.post('/crm/register', { user, username }, {
      headers: {
        accesstoken: store.getters.accessToken,
        idtoken: store.getters.idToken
      }
    });
    const cognitoUser: CognitoUser = await Auth.currentAuthenticatedUser();
    const currentSession = await Auth.currentSession();
    cognitoUser.refreshSession(currentSession.getRefreshToken(), async (err, session: CognitoUserSession) => {
      if (err) {
        throw new Error('Could not reload Session');
      }
      store.dispatch('setAccessToken', session.getAccessToken().getJwtToken());
      store.dispatch('setIdToken', session.getIdToken().getJwtToken());
      store.dispatch('setRefreshToken', session.getRefreshToken().getToken());
      
      const attributes = session.getIdToken().payload;
      const annoCod = attributes['custom:annocod'];
      const progCod = attributes['custom:progcod'];
      if(!annoCod || !progCod) {
        router.push({
          path: ROUTES_NAMES.otp,
          query: {
            client_id: store.getters.clientID,
            redirect_uri: store.getters.redirectURI
          }
        });
      }
      else redirectToCallbackURL();
    });
  } catch (error: any) {
    throw error;
  }
};
